import { FourOFour, Link, Text } from "@hashimukh/client-utils-js";
import React from "react";

export const NoMatch: React.FunctionComponent = () => {
	return <FourOFour>
		<Text>Want to validate certificates? Click <Link href="/validate-certificate">here</Link>.</Text>
	</FourOFour>
}